import request from "../helpers/request";
import {getBaseUrl} from "../helpers/request";
import {createRestfulApi} from "./createRestfulApi";
import download from "@/helpers/download";

const URL = {
    // 岗位管理
    GETROLES: "role/getRoles",
    DELETEROLE: "role/deleteRole",
    SAVEROLE: "role/saveRole",
    GETROLEBYID: "role/getRoleById",
    GET_ROLE_PERMISSION_TREE: "role/getRolePermissionTree",
    UPDATE_ROLE_PERMISSION: "role/updateRolePermission",

    // 单位管理
    GETTENANTDEPARTMENTS: "tenantDepartment/getTenantDepartments",
    DELETEENANTDEPARTMENTS: "tenantDepartment/deleteTenantDepartments",
    SAVEENANTDEPARTMENTS: "tenantDepartment/saveTenantDepartment",
    GETTENANTDEPARTMENTSBYID: "tenantDepartment/getTenantDepartmentById",

    // 人员管理
    GETTENANTDEPARTMENTUSER: "tenant/getTenantDepartmentUser",
    DELETETENANTDEPARTMENTUSER: "tenant/deleteTenantDepartmentUser",
    ENABLETENANTDEPARTMENTUSER: "tenant/enableTenantDepartmentUser",
    SAVETENANTDEPARTMENTUSER: "tenant/saveTenantDepartmentUser",
    GETTENANTDEPARTMENTUSERBYID: "tenant/getTenantDepartmentUserById",


    getTenantTraineeList: "tenant/getTenantTraineeList",
    saveTenantTrainee: "tenant/saveTenantTrainee",
    deleteTenantTrainee: "tenant/deleteTenantTrainee",
    getLearningInfoList: "tenant/getLearningInfoList",
    exportLearningInfo: "tenant/exportLearningInfo",

    USERIMPORT: "tenantTrainee/importUserInfo",
    DOWNLOADTEMPLATE: "tenantTrainee/getImportTenantTraineeTemplate"

};

export default {
    //岗位管理-岗位列表
    getUserRoles() {
        return request(URL.GETROLES, "POST");
    },
    //岗位管理-删除岗位
    deleteRole({id}) {
        return request(URL.DELETEROLE, "POST", {id});
    },
    //岗位管理-新增岗位或编辑岗位
    saveRole({id, name, code}) {
        return request(URL.SAVEROLE, "POST", {
            id,
            name,
            code,
        });
    },
    // 根据id获取单位详情
    getRoleById({id}) {
        return request(URL.GETROLEBYID, "POST", {id});
    },
    // 根据role id 获取权限树
    getRolePermissionTree(id) {
        return request(URL.GET_ROLE_PERMISSION_TREE, "POST", {id});
    },
    //单位管理-单位列表
    getTenantDepartments() {
        return request(URL.GETTENANTDEPARTMENTS, "POST");
    },
    //单位管理-删除单位
    deleteTenantDepartments({id}) {
        return request(URL.DELETEENANTDEPARTMENTS, "POST", {id});
    },
    //单位管理-新增单位或编辑单位
    saveTenantDepartment({contactName, contactPhone, id, name}) {
        return request(URL.SAVEENANTDEPARTMENTS, "POST", {
            contactName,
            contactPhone,
            id,
            name,
        });
    },
    // 根据id获取单位详情
    getTenantDepartmentById({id}) {
        return request(URL.GETTENANTDEPARTMENTSBYID, "POST", {id});
    },
    //人员管理-人员列表
    tenantDepartmentUser: createRestfulApi(URL.GETTENANTDEPARTMENTUSER, {
        queryParams: [],
    }),
    //人员管理-人员列表
    // getTenantDepartmentUser({tenantDepartmentId, roleId, keyword, page=1, size=10}){
    //     return request(URL.GETTENANTDEPARTMENTUSER, "POST",{
    //         tenantDepartmentId,
    //         roleId,
    //         keyword,
    //         page,
    //         size
    //     })
    // },
    //人员管理-删除人员
    deleteTenantDepartmentUser({id}) {
        return request(URL.DELETETENANTDEPARTMENTUSER, "POST", {
            id,
        });
    },
    //人员管理-启用停用  传0，停用
    enableTenantDepartmentUser({id, enable}) {
        return request(URL.ENABLETENANTDEPARTMENTUSER, "POST", {
            id,
            enable,
        });
    },
    //人员管理-添加人员或编辑人员
    saveTenantDepartmentUser({id, nickname, phone, roleIds, birthday}) {
        return request(URL.SAVETENANTDEPARTMENTUSER, "POST", {
            id,
            nickname,
            phone,
            roleIds,
            birthday,
        });
    },
    // 根据id获取人员详情
    getTenantDepartmentUserById({id}) {
        return request(URL.GETTENANTDEPARTMENTUSERBYID, "POST", {id});
    },
    getTenantTraineeList: createRestfulApi(URL.getTenantTraineeList, {
        queryParams: [],
    }),
    saveTenantTrainee(payload) {
        return request(URL.saveTenantTrainee, "POST", payload);
    },
    deleteTenantTrainee({id}) {
        return request(URL.deleteTenantTrainee, "POST", {id});
    },
    getLearningInfoList: createRestfulApi(URL.getLearningInfoList, {
        queryParams: [],
    }),
    async exportLearningInfo(id) {
        const file = await request(URL.exportLearningInfo, "POST", {id}, true);
        download(file, `学员数据.xls`);
    },
    getDownloadTemplateUrl() {
        return getBaseUrl() + "/" + URL.DOWNLOADTEMPLATE;
    },
    importDepartmentUser(payload) {
        console.log("api importDepartmentUser")
        return request(URL.USERIMPORT, "POST", payload, false, true);
    }
};
